
export default {
  props: {
    items: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rating: this.items.ratingvalue,
    }
  },
}
